import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useCart } from '../../../context/CartContext';
import TopBar from './components/TopBar';
import Header from './components/Header';
import Hero from './components/Hero';
import Marquee from './components/Marquee';
import Products from './components/Products';
import Story from './components/Story';
import Footer from './components/Footer';
import { copy, languages } from './data';
import './KidoLanding.css';

export default function KidoLanding() {
  const { i18n } = useTranslation();
  const { getCartCount } = useCart();

  // i18n can report "en-US" etc. - normalise to one of ka / en / ru
  const language = languages.find((l) => (i18n.language || 'ka').startsWith(l)) || 'ka';
  const t = copy[language];

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng); // same key the site's LanguageSwitcher uses
  };

  // Smooth in-page anchor scrolling, only while this page is mounted
  useEffect(() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const root = document.documentElement;
    const previous = root.style.scrollBehavior;
    if (!reduce) root.style.scrollBehavior = 'smooth';
    return () => { root.style.scrollBehavior = previous; };
  }, []);

  return (
    <main className="kido-landing">
      <Hero copy={t} />
      <Marquee />
      <Products copy={t} />
      <Story copy={t} />
      <Footer />
    </main>
  );
}
